/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component, Input } from '@angular/core';

import './log-cinematic-section-wrapper.component.less';

/**
 * @description
 *
 *  Wrapper component to be used by sections in a log cinematic view for header setting and container styling.
 *
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-section-wrapper',
    templateUrl: './log-cinematic-section-wrapper.component.html',
})
export class LogCinematicSectionWrapperComponent {
    /**
     * Text for the section header.
     */
    @Input()
    public header: string;

    /**
     * Optional icon for the section header.
     */
    @Input()
    public icon ?: string;
}
